import * as React from 'react';
import { withProps } from 'recompose';
import SelectDay from '@dpdgroupuk/fmx-ui/components/DayPicker';
import SubmitButton from '@dpdgroupuk/fmx-ui/components/SubmitButton';
import { useEnhancedReCaptchaBadge as useGoogleReCaptchaVisibleToggle } from '@dpdgroupuk/fmx-ui/components/GoogleRecaptcha';
import { useTracker } from '@dpdgroupuk/react-event-tracker';

import { CHD_STEPS } from '../../steps';
import { WIZARD_CHD } from '../../../../constants/analytics';

type Props = {
  data: Object,
  dates: Array<string>,
  onSelect: Function,
  onSubmit: Function,
};

const SelectDayStep = ({ data, dates, onSelect, onSubmit }: Props) => {
  const tracker = useTracker();
  useGoogleReCaptchaVisibleToggle();

  const onTrackableSelect = React.useCallback(
    (...args) => {
      tracker.logEvent(WIZARD_CHD.ON_DAY_SELECT);
      return onSelect(...args);
    },
    [onSelect, tracker]
  );

  const onTrackableSubmit = React.useCallback(
    (...args) => {
      tracker.logEvent(WIZARD_CHD.ON_SUBMIT);
      return onSubmit(...args);
    },
    [onSubmit, tracker]
  );

  return (
    <>
      <SelectDay
        title="Day of collection"
        subtitle="Select an upcoming day when you would like your parcel to be collected"
        selectedDate={data.day}
        onSelect={onTrackableSelect}
        dates={dates}
      />
      <SubmitButton onSubmit={onTrackableSubmit} isSubmitHidden={!data.day} />
    </>
  );
};

export default withProps(
  ({
    addStepData,
    submitWizard,
    goToStep,
    isNotificationDetailsAvailable,
  }) => ({
    onSelect: day => {
      addStepData({ day });
    },
    onSubmit: isNotificationDetailsAvailable
      ? submitWizard
      : () => goToStep(CHD_STEPS.GET_CONTACTS),
  })
)(SelectDayStep);
